function RRInstanceMaker($window) {
	const RRInstance = {};
	RRInstance.COMMON = $window.r3_common;
	RRInstance.ADD_TO_CART = $window.r3_addtocart;
	RRInstance.ADD_TO_WISHLIST = $window.r3_addtoregistry;
	RRInstance.BRAND_PAGE = $window.r3_brand;
	RRInstance.HOME_PAGE = $window.r3_home;
	RRInstance.CATEGORY_PAGE = $window.r3_category;
    RRInstance.DEPARTMENT_PAGE = $window.r3_category;
	RRInstance.ERROR_PAGE = $window.r3_error;
	RRInstance.PRODUCT_PAGE = $window.r3_item;
	RRInstance.MY_PROFILE_PAGE = $window.r3_personal;
	RRInstance.ORDER_COMPLETE_PAGE = $window.r3_purchased;
	RRInstance.SEARCH_PAGE = $window.r3_search;
	RRInstance.GENERIC_PAGE = $window.r3_generic;
    RRInstance.CART_PAGE = $window.r3_cart;
    RRInstance.WISHLIST_PAGE = $window.r3_wishlist;
    RRInstance.ITEM_PAGE = $window.window.r3_item;
	return RRInstance;
}

module.exports = RRInstanceMaker;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-instance-maker.js
 **/